import { createAction, props } from '@ngrx/store';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { SelectItem } from 'primeng/api';
import { CommonPatientModel } from 'src/app/model/common/patient';
import { CommonPatientViewModel } from 'src/app/model/common/patient.view';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';

enum CommonPatientLabel {
  SET_RESULT = 'COMMON_PATIENT_SET_RESULT',
  ADD_RESULT = 'COMMON_PATIENT_ADD_RESULT',
  PATCH_RESULT = 'COMMON_PATIENT_UPDATE_RESULT',
  SET_PATIENT = 'COMMON_PATIENT_SET_PATIENT',
  SET_RESIDENCE = 'COMMON_PATIENT_SET_RESIDENCE',
  SET_PATIENT_DEFAULT = 'COMMON_PATIENT_SET_PATIENT_DEFAULT',
  SET_ALL_DEFAULT = 'COMMON_PATIENT_SET_ALL_DEFAULT',
}

export const commonPatientActions = {
  setResultAction: createAction(
    CommonPatientLabel.SET_RESULT,
    props<VonPageResponseModel<CommonPatientViewModel>>()
  ),
  addResultAction: createAction(
    CommonPatientLabel.ADD_RESULT,
    props<CommonPatientViewModel>()
  ),
  patchResultAction: createAction(
    CommonPatientLabel.PATCH_RESULT,
    props<CommonPatientViewModel>()
  ),
  setPatientAction: createAction(
    CommonPatientLabel.SET_PATIENT,
    props<CommonPatientModel>()
  ),
  setResidenceAction: createAction(
    CommonPatientLabel.SET_RESIDENCE,
    props<SelectItem<KhuyanaSelectItemModel>>()
  ),
  setPatientDefaultAction: createAction(
    CommonPatientLabel.SET_PATIENT_DEFAULT,
    props<any>()
  ),
  setAllDefaultAction: createAction(
    CommonPatientLabel.SET_ALL_DEFAULT,
    props<any>()
  ),
};
